import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "onlinestate",
  style: {"min-width":"1280px"}
}
const _hoisted_2 = { class: "row align-items-start pb-2 pt-2" }
const _hoisted_3 = { class: "col-1 d-flex justify-content-start" }
const _hoisted_4 = { class: "col-1" }
const _hoisted_5 = { class: "col-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "col-1" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "col-1" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "col-1" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-1" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "col-1" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "col-1" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "col-1" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "row align-items-start pb-2 pt-2" }
const _hoisted_25 = { class: "col-2 d-flex justify-content-start" }
const _hoisted_26 = { class: "col-1" }
const _hoisted_27 = { class: "row align-items-start pb-2" }
const _hoisted_28 = { clas: "col-12" }
const _hoisted_29 = { class: "row align-items-start pb-2" }
const _hoisted_30 = {
  clas: "col-12",
  style: {"padding-left":"20px"}
}
const _hoisted_31 = { style: {"text-align":"center"} }
const _hoisted_32 = ["onUpdate:modelValue", "onClick"]
const _hoisted_33 = { style: {"text-align":"center"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { style: {"text-align":"center"} }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { style: {"text-align":"center"} }
const _hoisted_38 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rechnung_detail = _resolveComponent("rechnung-detail")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-1 d-flex justify-content-end label__adjust" }, " Jahr: ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select select__max",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getSelectedYear && _ctx.getSelectedYear(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (item, idYear) => {
            return (_openBlock(), _createElementBlock("option", { key: idYear }, _toDisplayString(item.year), 1))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedYear]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonRefresh && _ctx.onButtonRefresh(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm"
        }, " Anzeigen ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.selectCount==1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedBereich), 1))
          : _createCommentVNode("", true),
        (_ctx.selectCount!=1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "    Sel.: " + _toDisplayString(_ctx.selectCount), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonEmergencyDataCreate && _ctx.onButtonEmergencyDataCreate(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm",
          disabled: _ctx.isActionPossible()
        }, " Rett.erzeugen ", 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonEmergencyData && _ctx.onButtonEmergencyData(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm",
          disabled: _ctx.isActionPossible()
        }, " Rett.senden ", 8, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonCreateRequisition && _ctx.onButtonCreateRequisition(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm",
          disabled: _ctx.isActionPossible()
        }, " Best.erzeugen ", 8, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonShipRequisition && _ctx.onButtonShipRequisition(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm",
          disabled: _ctx.isActionPossible()
        }, " Best.senden ", 8, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonCreateInvoice && _ctx.onButtonCreateInvoice(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm",
          disabled: _ctx.isActionPossible()
        }, " Rech.erzeugen ", 8, _hoisted_17)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonShipInvoice && _ctx.onButtonShipInvoice(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size btn-sm",
          disabled: _ctx.isActionPossible()
        }, " Rech.senden ", 8, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonCreateReminder && _ctx.onButtonCreateReminder(...args)), ["prevent"])),
        class: "btn btn-outline-primary same__size",
        disabled: _ctx.isActionPossible()
      }, " Mahnung.erzeugen ", 8, _hoisted_21)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonShipReminder && _ctx.onButtonShipReminder(...args)), ["prevent"])),
        class: "btn btn-outline-primary same__size",
        disabled: _ctx.isActionPossible()
      }, " Mahnung.senden ", 8, _hoisted_23)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-1 d-flex justify-content-end label__adjust" }, " Mandant: ", -1)),
      _createElementVNode("div", _hoisted_25, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select select__max-mandant",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedMandant) = $event)),
          onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.getSelectedMandant && _ctx.getSelectedMandant(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mandants, (item, idMandant) => {
            return (_openBlock(), _createElementBlock("option", { key: idMandant }, _toDisplayString(item.mandant), 1))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedMandant]
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonCalculateReminders && _ctx.onButtonCalculateReminders(...args)), ["prevent"])),
          class: "btn btn-outline-primary same__size left_offset"
        }, " Mahnungslauf ")
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_rechnung_detail, {
          customerLink: _ctx.customerLink,
          Year: _ctx.selectedYear,
          standAlone: _ctx.documentStandAlone,
          onLoading: _ctx.loading
        }, null, 8, ["customerLink", "Year", "standAlone", "onLoading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_Grid, {
          ref: "grid",
          style: { height: '900px' },
          "selected-field": _ctx.selectedField,
          "data-items": _ctx.filteredData,
          columns: _ctx.columns,
          filterable: true,
          filter: _ctx.filter,
          sortable: true,
          sort: _ctx.sort,
          onSelectionchange: _ctx.onSelectionChange,
          onHeaderselectionchange: _ctx.onHeaderSelectionChange,
          onRowclick: _ctx.onRowClick,
          onFilterchange: _ctx.filterChange,
          onSortchange: _ctx.sortChange,
          onCustom: _ctx.customHandler
        }, {
          checkBoxColumn: _withCtx(({ props }) => [
            _createElementVNode("td", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((props.dataItem.bezahlt) = $event),
                onClick: ($event: any) => (_ctx.onCheckClick(props.dataItem))
              }, null, 8, _hoisted_32), [
                [_vModelCheckbox, props.dataItem.bezahlt]
              ])
            ])
          ]),
          bestellungPrint: _withCtx(({ props }) => [
            _createElementVNode("td", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                onClick: _withModifiers(($event: any) => (_ctx.onBestellungDownload(props.dataItem)), ["prevent"]),
                class: "btn btn-outline-primary btn-sm"
              }, " Anzeigen ", 8, _hoisted_34)
            ])
          ]),
          rechnungPrint: _withCtx(({ props }) => [
            _createElementVNode("td", _hoisted_35, [
              _createElementVNode("button", {
                type: "button",
                onClick: _withModifiers(($event: any) => (_ctx.onRechnungDownload(props.dataItem)), ["prevent"]),
                class: "btn btn-outline-primary btn-sm"
              }, " Anzeigen ", 8, _hoisted_36)
            ])
          ]),
          actionColumn: _withCtx(({ props }) => [
            _createElementVNode("td", _hoisted_37, [
              _createElementVNode("button", {
                type: "button",
                onClick: _withModifiers(($event: any) => (_ctx.onActionClick(props.dataItem)), ["prevent"]),
                class: "btn btn-outline-primary btn-sm"
              }, " Details ", 8, _hoisted_38)
            ])
          ]),
          myTemplate: _withCtx(({ props }) => [
            _createVNode(_component_rechnung_detail, {
              "data-item": props.dataItem
            }, null, 8, ["data-item"])
          ]),
          _: 1
        }, 8, ["selected-field", "data-items", "columns", "filter", "sort", "onSelectionchange", "onHeaderselectionchange", "onRowclick", "onFilterchange", "onSortchange", "onCustom"])
      ])
    ])
  ]))
}